// src/views/SecondPage.jsx
// PUBLIC "/second" — second reverse mortgages (e.g. FAR's HomeSafe Second):
// keep the low-rate first mortgage, add a lump sum behind it with no required
// monthly payment on the second. Same voice, styling and rules as /info: no
// forms or lead capture, phone and email only, and no dollar figures, rates
// or percentages. Footer is the shared <PublicFooter/>.

import React, { useEffect } from "react";
import { BRAND, PUBLIC_DISCLOSURES } from "../theme";
import { FontLoader, Wordmark, PublicFooter } from "../brand";
import { INFO_CSS, GuideBanner } from "./InfoPage";

function SecondPage(){
  useEffect(()=>{
    const prev=document.title;
    document.title="Keep Your Low Rate: The Second Reverse Mortgage — Reverse by Reece";
    return ()=>{document.title=prev;};
  },[]);
  const D=PUBLIC_DISCLOSURES.contact;

  return(<div className="rbr-info">
    <FontLoader/>
    <style>{INFO_CSS}</style>
    <GuideBanner product="hs2"/>
    <main className="page">

      <header className="masthead">
        <a href="/" aria-label="Reverse by Reece home"><Wordmark tone="navy" size={24}/></a>
        <div className="lic">{BRAND.loNmls} &nbsp;·&nbsp; {BRAND.companyNmls}</div>
      </header>

      <h1>Keep Your Low Rate. Add a Second Reverse Mortgage.</h1>
      <p className="subhead">For homeowners who locked in a great rate on their mortgage and don't want to give it up to get to their equity.</p>

      <h2>Start here</h2>
      <p>A second reverse mortgage — Finance of America's <strong>HomeSafe Second</strong> is the one I use most — sits behind the mortgage you already have.</p>
      <p><strong>Your first mortgage doesn't change.</strong> Same rate, same payment, same lender. The second is a separate loan that gives you a lump sum of cash from your equity, and it comes with no required monthly payment.</p>

      <h2>Why it exists</h2>
      <p>A lot of people refinanced when rates were at the bottom. Now they need real money — a remodel, paying off higher-interest debt, helping family, a cushion for retirement — and every usual option means giving up that rate.</p>
      <div className="compare">
        <div className="col">
          <div className="col-tag">Cash-out refinance</div>
          <h3>Your low rate goes away</h3>
          <p>You replace your whole mortgage at today's rate to pull cash out. That usually means a bigger balance at a higher rate and a new, larger monthly payment.</p>
        </div>
        <div className="col reverse">
          <div className="col-tag">Second reverse mortgage</div>
          <h3>Your low rate stays</h3>
          <p>Your first mortgage stays exactly where it is. The new money comes as a lump sum on a second loan, and there's no required monthly payment on it — the interest is added to that loan's balance instead.</p>
        </div>
      </div>

      <h2>What "no required payment" means</h2>
      <p>Nothing is due each month on the second. You can pay toward it whenever you want, or not at all — it gets settled when the home is sold or the loan otherwise comes due.</p>
      <p>What you're still responsible for:</p>
      <ul>
        <li>You keep making your first mortgage payment, the same as you do now</li>
        <li>You keep paying property taxes and homeowner's insurance</li>
        <li>You keep up the house and live in it as your primary home</li>
      </ul>

      <h2>Qualifying is a little different</h2>
      <p>This is the honest trade-off. A standard reverse mortgage has no minimum credit score. A second reverse mortgage takes a closer look: <strong>the lender reviews your credit and your payment history on the first mortgage</strong>, since that loan is staying in place and you'll keep paying it.</p>
      <p>What you get for clearing that bar is often a <strong>much lower-cost loan</strong>. It's a private program with no FHA mortgage insurance, and you're only borrowing the cash you need — not refinancing your whole mortgage to get it. For the right homeowner, that combination is hard to beat.</p>
      <p>Age and state rules apply, and not every home or borrower qualifies. I'll tell you on the first call whether it's available where you live.</p>

      <h2>Who it tends to fit</h2>
      <ul>
        <li>You have a first mortgage with a low rate you want to keep</li>
        <li>You have solid equity in the home</li>
        <li>You want a larger lump sum without adding a monthly payment</li>
        <li>Your credit and mortgage payment history are in good shape</li>
      </ul>
      <p>If that isn't you, a standard reverse mortgage may be the better fit — <a href="/info">here's how that one works</a>.</p>

      <h2>When you sell</h2>
      <p>Both loans are paid off from the sale, first mortgage first, and <strong>whatever equity is left is yours</strong> or your family's. You can sell whenever you want.</p>

      <h2>See if it works on your house</h2>
      <p>I'll run it next to the other options — including leaving everything alone — and tell you straight which one makes sense.</p>
      <div className="contact" id="guide-contact">
        <div className="who">{D.name}</div>
        <div className="row">
          {D.phones.map(p=>(
            <a key={p.label} href={p.href}><span className="phone-label">{p.label}:</span> {p.num}</a>
          ))}
          <a href={"mailto:"+D.email}>{D.email}</a>
          <span className="site">{D.site}</span>
        </div>
      </div>

      <p style={{fontSize:13,lineHeight:1.6,color:"#4A5260",marginTop:26}}>HomeSafe Second is a proprietary program of Finance of America Reverse LLC and is not FHA-insured. Subject to credit approval, program guidelines and state availability.</p>

      <footer><PublicFooter/></footer>
    </main>
  </div>);
}

export { SecondPage };
